import React from 'react';

const Poland = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" fill="#AF010D" />
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <path fillRule="evenodd" clipRule="evenodd" d="M0 0H28V10.6667H0V0Z" fill="white" />
  </svg>
);

export default Poland;
